"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4747],{

/***/ 62810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

exports.Z = _default;

/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ }),

/***/ 24312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 24;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "22",
                    height: "22",
                    rx: "2",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "22",
                    height: "22",
                    rx: "2",
                    stroke: color,
                    strokeWidth: "2"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 70612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 24;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "23.5",
                height: "23.5",
                rx: "2.75",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 8L10.1667 16L6.5 12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "23.5",
                height: "23.5",
                rx: "2.75",
                stroke: color,
                strokeWidth: "0.5"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 34515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkbox_FormCheckBoxWithLable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/CheckBoxOutlineBlankOutlined.js


/* harmony default export */ var CheckBoxOutlineBlankOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlankOutlined'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBox.js
var CheckBox = __webpack_require__(62810);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikCheckbox.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  .MuiFormControlLabel-label {\n    text-align: start !important;\n  }\n  .Mui-focusVisible {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin-left: 7px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: -0.5em;\n  right: 0px;\n  text-align: start !important;\n  font-size: 12px !important;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormikCheckbox__StyledContainer",
    componentId: "sc-d4f714ca-0"
})(_templateObject());
var StyledCheckboxWithLabel = (0,styled_components_browser_esm/* default */.ZP)(formik_material_ui_es6/* CheckboxWithLabel */.$B).withConfig({
    displayName: "FormikCheckbox__StyledCheckboxWithLabel",
    componentId: "sc-d4f714ca-1"
})(_templateObject1());
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(FormHelperText/* default */.Z).withConfig({
    displayName: "FormikCheckbox__StyledError",
    componentId: "sc-d4f714ca-2"
})(_templateObject2());
var FormikCheckbox = function(_param) {
    var name = _param.name, label = _param.label, required = _param.required, inputRef = _param.inputRef, children = _param.children, normalIcon = _param.normalIcon, checkedIcon = _param.checkedIcon, labelText = _param.labelText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "inputRef",
        "children",
        "normalIcon",
        "checkedIcon",
        "labelText"
    ]);
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, touched = ref.touched;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Field, (0,_object_spread/* default */.Z)({
                        component: StyledCheckboxWithLabel,
                        type: "checkbox",
                        required: required,
                        icon: normalIcon ? normalIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxOutlineBlankOutlined, {
                            fontSize: "small",
                            color: "inherit"
                        }),
                        checkedIcon: checkedIcon ? checkedIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                            fontSize: "small",
                            color: "inherit"
                        }),
                        name: name,
                        Label: {
                            label: label,
                            style: {
                                marginLeft: 0,
                                alignItems: "center"
                            }
                        },
                        inputRef: inputRef,
                        inputProps: {
                            "aria-describedby": "".concat(name, "-helper-text"),
                            "aria-label": labelText
                        }
                    }, props)),
                    children
                ]
            }),
            errors[name] && touched[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                id: "".concat(name, "-helper-text"),
                error: true,
                children: errors[name]
            })
        ]
    });
};
/* harmony default export */ var form_FormikCheckbox = (FormikCheckbox);

// EXTERNAL MODULE: ./reusable/formsComp/checkbox/CheckBoxIcon.tsx
var CheckBoxIcon = __webpack_require__(24312);
// EXTERNAL MODULE: ./reusable/formsComp/checkbox/CheckBoxSelectedIcon.tsx
var CheckBoxSelectedIcon = __webpack_require__(70612);
;// CONCATENATED MODULE: ./reusable/formsComp/checkbox/FormCheckBoxWithLable.tsx

function FormCheckBoxWithLable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: start;\n  line-height: 1.3;\n  color: ",
        ";\n  a {\n    font-size: 12px;\n    text-decoration: underline;\n  }\n"
    ]);
    FormCheckBoxWithLable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledLableText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "FormCheckBoxWithLable__StyledLableText",
    componentId: "sc-818bf4b5-0"
})(FormCheckBoxWithLable_templateObject(), function(p) {
    return p.theme.colors.black;
});
var FormCheckBoxWithLable = function(param) {
    var name = param.name, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikCheckbox, {
            name: name,
            normalIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {}),
            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxSelectedIcon/* default */.Z, {}),
            labelText: label,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLableText, {
                children: label
            })
        })
    });
};
/* harmony default export */ var checkbox_FormCheckBoxWithLable = (FormCheckBoxWithLable);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ })

}]);